<!--
 * @FileDescription: 考勤表单
 * @Author: wh
 * @Date: 2020-12-11 13:17:21
 * @LastEditors: 陈瑞军
 * @LastEditTime: 2021-10-19 16:53:43
-->
<template>
  <yxt-drawer
    v-drawerloading="loading"
    :title="titleInternalKey?$t(titleInternalKey):title"
    :before-close="beforeCloseHandle"
    :visible.sync="drawerVisible"
    direction="rtl"
    :size="parseInt(size)>parseInt(maxWidth)?maxWidth:size"
  >
    <yxt-form ref="form" :model="form" :rules="rules">
      <!-- 批阅人 -->
      <yxt-form-item :label="$t('pc_ulcd_lbl_remarkperson')" class="mb0">
        <yxt-radio-group v-model="form.remarkType" :direction="'row'">
          <yxt-radio :label="1">{{ $t('pc_ulcd_lbl_instructorremark') }}</yxt-radio>
          <yxt-radio :label="5">{{ $t('pc_ulcd_lbl_designpersonremark') }}<yxt-button v-if="form.remarkType === 5" type="primary" class="ml16" @click="personSelectDialog = true">{{ $t('pc_ulcd_lbl_designperson') }}</yxt-button></yxt-radio>
        </yxt-radio-group>
      </yxt-form-item>
      <yxt-form-item prop="users">
        <template v-if="form.users.length > 0 && form.remarkType===5">
          <yxt-tag v-for="user in form.users" :key="user.id" type="info" closable class="ml5" @close="delUser(user)"><yxtbiz-user-name :name="user.fullname" /></yxt-tag>
        </template>
      </yxt-form-item>
    </yxt-form>

    <div slot="footer">
      <yxt-button plain @click="beforeCloseHandle">{{ $t('pc_ulcd_btn_cancel') }}</yxt-button>
      <yxt-button type="primary" @click="submitHandle">{{ $t('pc_ulcd_btn_done') }}</yxt-button>
    </div>
    <!-- 选择指定批阅人 functionCode 默认为 o2o_train_center -->
    <yxt-drawer :size="parseInt(selectorSize)>parseInt(maxWidth)?maxWidth:selectorSize" destroy-on-close append-to-body :visible.sync="personSelectDialog">
      <yxt-user-selector
        ref="selector"
        :data="users"
        :limit="30"
        :tabs="tabs"
        :enableGroupCorp="!!groupOrgFlag"
        :dataPermissionCode="groupOrgFlag?groupDataPermissionCode:dataPermissionCode"
        :functionCode="groupOrgFlag?groupFunctionCode:functionCode"
      ></yxt-user-selector>
      <div slot="footer">
        <yxt-button plain @click="cancelUser">{{ $t('pc_ulcd_btn_cancel') }}</yxt-button>
        <yxt-button type="primary" @click="getUsers">{{ $t('pc_ulcd_btn_done') }}</yxt-button>
      </div>
    </yxt-drawer>
  </yxt-drawer>
</template>

<script>

export default {
  components: {

  },
  props: {
    // '1'-添加考勤 '2'-面授中考勤
    type: { type: String, default: '1' },
    // 后台配置
    visible: { type: Boolean, default: false }, // 业务组件抽屉是否显示
    title: { type: String, default: '' },
    titleInternalKey: { type: String, default: '' }, // 对应2.0平台中业务组件模块下的国际化key
    oprateType: {// 组件操作类型：1-添加 2-编辑 3-草稿状态编辑
      type: Number,
      default: 1
    },
    pagePropertyConfig: {
      type: Object,
      default: () => {
        return {
        };
      }
    }, // 接收JSON对象，业务组件内属性配置-对应业务方特需定的配置，比如别名，是否必填，是否显示字段，可对业务组件内的各个字段进行配置
    bizComponentConfig: { type: Object,
      default: () => {
        return {
        };
      }
    }, // 接收JSON对象，业务组件的常规配置-对应组件库中的常规配置项，比如functionCode,dataPermissionCode，其中size为基础必填配置项，代表抽屉宽度大小
    appCode: { type: String, default: '' }, // 业务来源，使用此业务组件的具体业务方的来源信息，业务组件可通过此属性进行特定的业务逻辑判定
    taskInfo: { type: Object, default: () => { return {}; } }, // 用于业务数据修改时的回显，此值即任务应用添加时返回的用户数据JSON
    taskBase: { type: Object, default: () => { return {}; } }, // 用于业务数据修改时的回显,一般结合taskInfo使用，切里面的字段是互斥的
    isPublished: { type: Number, default: 0 }, // 是否为已发布状态，代表该任务活动是否已发布，用于控制某些表单字段是否禁用，需要业务方的页面属性配置进行禁用控制
    groupOrgFlag: { type: Number, default: 0 }, // 当前ULCD环境是否为集团版环境，0-否 1-是，默认为0，此值为方便业务组件拿到当前ULCD环境状态，具体是否使用到此值以任务应用方为准
    maxWidth: { type: String, default: ' 960px' }, // 抽屉最大宽度
    taskVersion: { type: String, default: '' }// 组件版本，用于数据回传
  },
  data() {
    return {
      personSelectDialog: false, // 选人组件
      formCfg: {
      },
      pulishedConfig: {
      },
      AppID: '1539454469219870721',
      bizData: { meta: { taskId: '', taskVersion: '' },
        taskInfo: {},
        taskBase: {
          name: '',
          typeName: '新考勤', // 待暴露
          required: 1
        }
      },
      rules: {
      },
      form: {
        users: [],
        remarkType: 1 // 批阅方式
      },
      size: '500px',
      centerDialogVisible: false,
      tabs: ['persons', 'userGroup', 'advance'],
      functionCode: '',
      dataPermissionCode: '',
      selectorSize: '100px',
      groupDataPermissionCode: '',
      groupFunctionCode: ''
    };
  },
  computed: {
    drawerVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      }
    }
  },
  watch: {
    visible: {
      handler(nval, oval) {
        let isObj = (val) => Object.prototype.toString.call(val) === '[object Object]';
        let getVal = (target) => isObj(target) ? (target['value'] || target['defVal']) : '';
        if (nval === true) {
          this.bizData.meta = { taskId: this.AppID, taskVersion: this.taskVersion };
          const { functionCode, dataPermissionCode, groupFunctionCode, groupDataPermissionCode } = this.bizComponentConfig;
          if (this.groupOrgFlag === 1) {
            this.groupFunctionCode = getVal(groupFunctionCode);
            this.groupDataPermissionCode = getVal(groupDataPermissionCode);
          }
          this.functionCode = getVal(functionCode);
          this.dataPermissionCode = getVal(dataPermissionCode);
        } else {
          this.setPageConfig();
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.setConfig();
  },
  methods: {
    showUsersBox() {
      this.personSelectDialog = true;
    },
    cancelUser() {
      this.personSelectDialog = false;
    },
    delUser(user) {
      this.form.users.splice(this.form.users.indexOf(user), 1);
      // this.formRef.validateField('users')
    },
    getUsers() {
      this.$refs.selector.getSelected().then(res => {
        this.form.users = res;
        this.personSelectDialog = false;
      }).catch(e => {
        console.error(e);
      });
    },
    getBizData() {
      let bizData = JSON.parse(JSON.stringify(this.bizData));

      return bizData;
    },
    submitHandle() { // 完整业务数据，可为单条数据，也可为多条组合数据
      this.$refs['form'].validate((valid) => {
        if (valid) {
          let bizData = this.getBizData();
          this.$emit('submitHandle', bizData);
          this.drawerVisible = false;
          console.log('submitHandle');// 此数据代表用户选择或提交的表单数据，为完整的业务记录数据
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    cancelHandle() { // 业务数据，可为null
      let bizData = this.getBizData();
      this.$emit('cancelHandle', bizData);
      console.log('cancelHandle');// 此数据代表用户已填表单数据，可能是部分表单数据
    },
    draftSaveHandle() { // 业务数据
      let bizData = this.getBizData();
      this.$emit('draftSaveHandle', bizData);
      console.log('draftSaveHandle');// 此数据代表用户已填表单数据，可能是部分表单数据
    },
    beforeCloseHandle() {
      let hasValue = false;
      for (let key in this.form) {
        let val = this.form[key];
        switch (Object.prototype.toString.call(val)) {
          case '[object String]' :
            if (val !== '') { hasValue = true; } break;
          case '[object Boolean]]' :
            if (val) { hasValue = true; } break;
          case '[object Array]]' :
            if (val.length > 0) { hasValue = true; } break;
        }
      }
      if (hasValue) {
        // 这里弹框
        this.$confirm('是否保存草稿？')
          .then(_ => {
            this.draftSaveHandle();
            this.drawerVisible = false;
          })
          .catch(_ => {
            this.draftCleanTest();
            this.drawerVisible = false;
          });
      } else {
        this.cancelHandle();
        this.drawerVisible = false;
      }
    },
    setConfig() {
      this.setPageConfig();
      this.setBizConfig();
    },
    setPageConfig() {
      const keys = Object.keys(this.pagePropertyConfig);
      keys.forEach((key) => {
        const val = this.pagePropertyConfig[key];

        const { required, showState, otherName, otherNameInternalKey } = val;
        this.formCfg[`${key}ShowState`] = showState;
        this.formCfg[key] = (otherNameInternalKey && this.$t(otherNameInternalKey)) || otherName || this.formCfg[key];
        if (this.rules[key]) {
          this.rules[key][0]['required'] = Boolean(required);
        }
        if (this.oprateType === 1) {
          this.form[key] = val['defVal'];
        }
      });
    },
    setBizConfig() {
      Object.keys(this.bizComponentConfig).forEach((item) => {
        const { defVal, value } = this.bizComponentConfig[item];
        if (this.hasOwnProperty(item)) {
          this[item] = value || defVal;
        }
      });
    },
    draftCleanTest() {
      this.$emit('draftSaveHandle', {});
      this.resetForm();
    },

    // 恢复默认值
    setDataDefault() {
    }
  }
};
</script>
